import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';

import { map } from 'rxjs/operators';
import { v4 as uuid4 } from 'uuid';
import { ResponseModel } from '../models/response.model';
import { AlertService } from './alert.service';
import { AuthService } from './auth.service';
import { RoleNames } from '../constants/role-names';
import { FireCollection } from '../constants/firestore-collection';
@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(
    private fireStore: AngularFirestore,
    private angularAuth: AngularFireAuth,
    private alertService: AlertService,
    private authService: AuthService,
    private fireStorage: AngularFireStorage
  ) { }
    getAllMerchants() {
      this.alertService.startLoadingMessage();
      return this.fireStore.collection(FireCollection.USER, ref => {
      return ref.where('roles', '==', RoleNames.Merchant );
    }).snapshotChanges().pipe(map(res => {
        this.alertService.stopLoadingMessage();
        const fireResponse: any[] = [];
        res.forEach((element, index) => {
          fireResponse.push( {} );
          Object.assign(fireResponse[index], {id: element.payload.doc.id}, element.payload.doc.data() );
        });
        const responseModel = new ResponseModel();
        responseModel.data = fireResponse;
        responseModel.count = fireResponse.length;
        responseModel.message = undefined;
        return responseModel;
      }));
    }
  getAll(collection: string, disableQuery = false) {
    this.alertService.startLoadingMessage();
    return this.fireStore.collection(collection, ref => {
      if (!disableQuery) {
        if (!this.authService.isRole(RoleNames.Administrator)) {
        return  ref.where('userId', '==', this.authService.currentUser.id);
        }
      }
    return ref;
  }).snapshotChanges().pipe(map(res => {
      this.alertService.stopLoadingMessage();
      const fireResponse: any[] = [];
      res.forEach((element, index) => {
        fireResponse.push( {} );
        Object.assign(fireResponse[index], {id: element.payload.doc.id}, element.payload.doc.data() );
      });
      const responseModel = new ResponseModel();
      responseModel.data = fireResponse;
      responseModel.count = fireResponse.length;
      responseModel.message = undefined;

      return responseModel;
    }));
  }
  async updateData(collection: string, id: string, data: any, isArray = false) {

    try {
      if (id.length < 20 || id === undefined || id === null) {
        this.alertService.showWarningMessage('Invalid ID');
        throw new Error('Invalid id');
      }
        this.alertService.startLoadingMessage('Updating');
        if (isArray) {
          const arrayData =
          data.map(element => {
            return Object.assign({}, element);
          });
          return this.fireStore.collection(collection).doc(id).set({data: arrayData}, {merge: true});
        } else {
          if (data['userId'] === undefined) {
            data['userId'] = this.authService.currentUser.id;
          }
          return this.fireStore.collection(collection).doc(id).set(await this.checkImage(Object.assign({}, data, )), {merge: true});
        }


    } catch (err) {
      console.log(err);
      this.alertService.showWarningMessage('Invalid id');
    }

  }

  getDataById(collection: string, id: string, addId = false) {
    this.alertService.startLoadingMessage();
    return this.fireStore.collection(collection).doc(id).get().pipe(map(res => {

      this.alertService.stopLoadingMessage();
      const fireResponse: any[] = [];

        fireResponse.push( {} );
        if ( !addId) {
          Object.assign(fireResponse[0], {id: res.id}, res.data() );
        }


      const responseModel = new ResponseModel();
      responseModel.data = fireResponse;
      responseModel.count = fireResponse.length;
      responseModel.message = undefined;

      return responseModel;
    }));
  }

  deleteData(collection: string, id: string) {
    this.alertService.startLoadingMessage('Deleting');
    return this.fireStore.collection(collection).doc(id).delete();
  }

  async addData(collection: string, data: any) {
    this.alertService.startLoadingMessage('Adding');


    return this.fireStore.collection(collection).doc().set(await this.checkImage(Object.assign({}, data, {userId: this.authService.currentUser.id})));
  }
  async checkImage(object: any) {
    for (const key in object) {
      if (typeof(object[key]) !== 'object' ) {
        if (typeof(object[key]) === 'string') {
          const data: string = object[key];
          if (data.startsWith('data:image')) {
            object[key] = await this.storeImage(object[key]);
          }
        }

      } else {
        this.checkImage(object[key]);
      }
    }
    return object;
  }

  async storeImage(base64: string) {
    const sotrageRef = this.fireStorage.ref('images/' + uuid4() + '.jpg');
    const splittedImage = base64.split('/');
    const formate = splittedImage[1].split(';');
    const image = await  sotrageRef.putString(base64, 'data_url', {contentType: 'image/' + formate[0]});
    return image.ref.getDownloadURL();
  }


}
